export default __webpack_public_path__ + "static/media/hydra.5fe2850f.png";